// extracted by mini-css-extract-plugin
export default {"scrollToTop":"styles_scrollToTop__uK6zD","active":"styles_active__n8iya","upText":"styles_upText__uh7yo","notHover":"styles_notHover__JtbnO"};